import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import AutosizeInput from 'react-input-autosize'

import { saveAlternatives, deleteAlternative, updateAlternativesButtons, updateAlternativesQuestion, saveAlternativesActionDetail, updateModalError } from 'redux/smartchat/alternatives/actions'
import { DotsOptionsSelector } from 'components/common'
import { Button } from 'components/Form'
import { Text } from 'components/SmartChatView/Fields'
import ModalWrapper from 'components/ModalWrapper'
import ModalDelete from 'components/ModalDelete'
import ActionModal from '../ActionModal'
import ActionCard from '../ActionCard'
import ActionButtons from './ActionButtons'
import { getStaticImage } from 'utils/statics'

const AlternativesModalUI = ({
  isOpen,
  toggle,
  alternativesId,
  fromAlternativesId,
  previewActionRef,
  isOpenOptionsSelector,
  toggleOptionsSelector,
  isEditingQuestion,
  toggleEditQuestion,
  alternativeText,
  setAlternativeText,
  handleAlternativeText,
  alternativeSelected,
  alternativesData,
  alternativesLevel,
  isOpenActionModal,
  toggleActionModal,
  isOpenDeleteActionModal,
  toggleDeleteActionModal,
  isOpenAlternativeModal,
  toggleAlternativeModal,
  isOpenDeleteAlternativeModal,
  toggleDeleteAlternativeModal,
  alternativesButtonsActive,
  setAlternativesButtonsActive,
  modalError,
  loading,
  error,
  dispatch
}) => (
  <ModalWrapper
    id='alternativesModal'
    isOpen={isOpen}
    toggle={() => toggle({ alternativesId })}
    isEnabledSwitch
    valueSwitch={alternativesData.buttons}
    onChangeSwitch={value => dispatch(updateAlternativesButtons({ alternativesId, buttons: value }))}
    header={`${I18n.t('smartchat_actions_showAlternatives')} - ${I18n.t('dashboard_level')} ${alternativesLevel}`}
    eventBtnTxt={I18n.t('dashboard_save')}
    eventBtn={() => dispatch(saveAlternatives({ alternativesId, fromAlternativesId, previewActionRef, onFinish: toggle }))}
    cancelBtnTxt={I18n.t('dashboard_cancel')}
    cancelBtn={() => toggle({ alternativesId })}
    keyboard={false}
    contentClassName='smartchat-modal'
    isSubmitting={loading}
    error={error && I18n.t(error.message)}
    body={
      <div className='alternatives-modal'>
        <div className='alternatives-modal__content'>
          <div className='alternatives-modal__questions-container'>
            <div className='alternatives-modal__question-container'>
              {!isEditingQuestion ? (
                <>
                  <label className='alternatives-modal__question'>{alternativesData.questionText || I18n.t('dashboard_write-question-here')}</label>
                  <button type='button' onClick={toggleEditQuestion}>
                    <figure>
                      <img
                        className='pointer'
                        src={getStaticImage('/icons/orange-brand/icon-edit-2.svg')}
                        alt='Edit question'
                      />
                    </figure>
                  </button>
                </>
              ) : (
                <>
                  <label>
                    <AutosizeInput
                      className='alternatives-modal__question'
                      value={alternativesData.questionText}
                      placeholder={I18n.t('dashboard_write-question-here')}
                      onChange={event => dispatch(updateAlternativesQuestion({
                        alternativesId,
                        questionText: event.target.value
                      }))}
                      onKeyPress={event => event.key === 'Enter' && toggleEditQuestion()}
                    />
                  </label>
                  <button type='button' onClick={toggleEditQuestion}>
                    <figure>
                      <img
                        className='pointer'
                        src={getStaticImage('/icons/orange-brand/icon-edit-2.svg')}
                        alt='Edit question'
                      />
                    </figure>
                  </button>
                </>
              )}
            </div>
            <div className='line-dotted'></div>
          </div>
          <div className='alternatives-modal__answers-container custom-scrollbar'>
            <div className='alternatives-modal__answers-list'>
              {alternativesData.alternativeList.map((alternative, index) => (
                <div key={index} className='alternatives-modal__answer-container'>
                  <div className='alternatives-modal__answer-btn'>
                    <p className='text-ellipsis'>{alternative.alternativeText}</p>
                    <DotsOptionsSelector
                      isOpen={isOpenOptionsSelector[alternative.id]}
                      toggle={() => toggleOptionsSelector(alternative.id)}
                      options={[
                        {
                          name: I18n.t('dashboard_edit'),
                          onClick: () => toggleAlternativeModal(alternative.id)
                        },
                        {
                          name: I18n.t('dashboard_delete'),
                          onClick: () => toggleDeleteAlternativeModal(alternative.id)
                        }
                      ]}
                      position='top'
                    />
                  </div>
                  <div className='alternatives-modal__actions-container custom-scrollbar'>
                    {(alternative.alternativeActions.onNewProcess.actionList.length > 0 || alternative.alternativeActions.onProcess[0].actionList.length > 0) && (
                      <div className='alternatives-modal__actions'>
                        <div className='alternatives-modal__new-process'>
                          {alternative.alternativeActions.onNewProcess.actionList.map((action, index) => (
                            <ActionCard
                              key={index}
                              actionDetail={action}
                              modalActionRef={{
                                actionType: 'botAction',
                                containerType: 'onNewProcess',
                                actionIndex: index,
                                alternativeId: alternative.id
                              }}
                              dataWay={{ type: 'alternatives', alternativesId }}
                              toggleActionModal={toggleActionModal}
                              toggleDeleteActionModal={toggleDeleteActionModal}
                            />
                          ))}
                          {alternative.alternativeActions.onProcess[0].actionList.length > 0 && (
                            <Button
                              className='alternatives-modal__bot-btn'
                              container
                              containerPrimary
                              value={I18n.t('chatbot_button_botAction')}
                              onClick={() => toggleActionModal({
                                mode: 'add',
                                actionType: 'botAction',
                                containerType: 'onNewProcess',
                                alternativeId: alternative.id
                              })}
                            />
                          )}
                        </div>
                        {alternative.alternativeActions.onProcess[0].actionList.length > 0 && (
                          <div className='alternatives-modal__process'>
                            {alternative.alternativeActions.onProcess[0].actionList.map((action, actionIndex) => (
                              <div key={actionIndex} className='alternatives-modal__actions-section'>
                                <ActionCard
                                  actionDetail={action}
                                  modalActionRef={{
                                    actionType: action.actionType,  // customerAction/operatorAction
                                    containerType: 'onProcess',
                                    actionIndex,
                                    alternativeId: alternative.id
                                  }}
                                  dataWay={{ type: 'alternatives', alternativesId }}
                                  toggleActionModal={toggleActionModal}
                                  toggleDeleteActionModal={toggleDeleteActionModal}
                                />
                                {action.botActionList.map((botAction, botActionIndex) => (
                                  <ActionCard
                                    key={botActionIndex}
                                    actionDetail={botAction}
                                    modalActionRef={{
                                      actionType: 'botAction',
                                      containerType: 'onProcess',
                                      actionIndex: botActionIndex,
                                      fromActionType: action.actionType,
                                      fromAction: action.actionSubtype,
                                      fromActionIndex: actionIndex,
                                      alternativeId: alternative.id
                                    }}
                                    dataWay={{ type: 'alternatives', alternativesId }}
                                    toggleActionModal={toggleActionModal}
                                    toggleDeleteActionModal={toggleDeleteActionModal}
                                  />
                                ))}
                                {actionIndex !== alternative.alternativeActions.onProcess[0].actionList.length - 1 && (
                                  <Button
                                    className='btn-bot'
                                    container
                                    containerPrimary
                                    value={I18n.t('chatbot_button_botAction')}
                                    onClick={() => toggleActionModal({
                                      mode: 'add',
                                      actionType: 'botAction',
                                      containerType: 'onProcess',
                                      fromActionType: action.actionType,
                                      fromAction: action.actionSubtype,
                                      fromActionIndex: actionIndex,
                                      alternativeId: alternative.id
                                    })}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    <ActionButtons
                      alternative={alternative}
                      alternativesButtonsActive={alternativesButtonsActive}
                      setAlternativesButtonsActive={setAlternativesButtonsActive}
                      toggleActionModal={toggleActionModal}
                    />
                  </div>
                </div>
              ))}
              <button
                type='button'
                className='alternatives-modal__answer-btn alternatives-modal__answer-btn--new'
                onClick={() => toggleAlternativeModal()}
              >
                {I18n.t('dashboard_add-answer')}
              </button>
            </div>
          </div>
        </div>

        {/* Modal para añadir una respuesta */}
        <ModalWrapper
          isOpen={isOpenAlternativeModal}
          toggle={() => toggleAlternativeModal()}
          header={!alternativeSelected ? I18n.t('dashboard_add-answer') : I18n.t('dashboard_edit-answer')}
          legend={!alternativeSelected ? I18n.t('smartchat_alternatives_addAnswer_legend') : I18n.t('smartchat_alternatives_editAnswer_legend')}
          eventBtnTxt={I18n.t('dashboard_save')}
          eventBtn={handleAlternativeText}
          cancelBtnTxt={I18n.t('dashboard_cancel')}
          cancelBtn={() => toggleAlternativeModal()}
          error={modalError && I18n.t(modalError.message)}
          contentClassName='smartchat-modal'
          body={
            <div className='modal-content modal-content--spaced'>
              <Text
                isRequired
                label={I18n.t('dashboard_name')}
                placeholder={I18n.t('dashboard_example_welcome')}
                value={alternativeText}
                onChange={value => {
                  if (modalError) dispatch(updateModalError(null))
                  setAlternativeText(value)
                }}
              />
            </div>
          }
        />

        {/* Modal para eliminar una respuesta */}
        <ModalDelete
          isOpen={isOpenDeleteAlternativeModal}
          toggle={toggleDeleteAlternativeModal}
          header={I18n.t('dashboard_delete-answer')}
          text1={I18n.t('smartchat_alternatives_removeAnswer_title')}
          text2={I18n.t('dashboard_action-cannot-reversed')}
          event={() => dispatch(deleteAlternative({
            alternativesId,
            alternativeId: alternativeSelected,
            onFinish: toggleDeleteAlternativeModal
          }))}
        />

        {/* Modal para añadir una acción */}
        {isOpenActionModal && (
          <ActionModal
            isOpen={isOpenActionModal}
            toggle={toggleActionModal}
            dataWay={{ type: 'alternatives', alternativesId }}
          />
        )}

        {/* Modal para eliminar una acción */}
        <ModalDelete
          isOpen={isOpenDeleteActionModal}
          toggle={toggleDeleteActionModal}
          header={I18n.t('dashboard_delete-action')}
          text1={I18n.t('dashboard_sure-want-delete-action')}
          text2={I18n.t('dashboard_process-cannot-reversed')}
          event={() => dispatch(saveAlternativesActionDetail({ alternativesId, onFinish: toggleDeleteActionModal }))}
        />
      </div>
    }
  />
)

export default AlternativesModalUI
